import api from '@/api/apiTmaps/apiConfig';

export default {
  async get(context) {
    try {
      let configs;
      const overrideAcnt = context.rootState.user.overrideAccount;
      const configResponse = await api.get(overrideAcnt);
      if (configResponse.status === 200) {
        configs = configResponse.data;
      }
      if (configs) {
        context.commit('set', configs);
      }
    } catch (error) {
      throw error;
    }
  },

  async edit({ commit, dispatch }, { id, params, throwError = true }) {
    try {
      let config;
      const paramsWithTimestamp = params;
      paramsWithTimestamp.updated = Date.now();
      const configResponse = await api.edit(id, paramsWithTimestamp);
      if (configResponse.status === 200) {
        config = configResponse.data;
      }
      if (config) {
        commit('set', config);
      }
    } catch (e) {
      if (throwError) {
        dispatch('errorHandler/throwDefaultError', e, { root: true });
      }
    }
  },

  async create(context, params) {
    try {
      const overrideAcnt = context.rootState.user.overrideAccount;
      const configResponse = await api.create(params, overrideAcnt);
      if (configResponse.status === 200) {
        return configResponse.data;
      }
      return null;
    } catch (e) {
      context.dispatch('errorHandler/throwDefaultError', e, { root: true });
      return null;
    }
  },

  async createPreview({ dispatch }, { id, params }) {
    try {
      await api.createPreview(id, params);
    } catch (e) {
      dispatch('errorHandler/throwDefaultError', e, { root: true });
    }
  },

  async getById({ commit, dispatch }, id) {
    try {
      let config;
      const configResponse = await api.getById(id);
      if (configResponse.status === 200) {
        config = configResponse.data;
      }
      if (config) {
        commit('setEditing', config);
      }
    } catch (e) {
      dispatch('errorHandler/throwDefaultError', e, { root: true });
    }
  },

  async deleteById({ commit, dispatch }, id) {
    try {
      let configs;
      const configsResponse = await api.deleteById(id);
      if (configsResponse.status === 200) {
        configs = configsResponse.data;
      }
      if (configs) {
        commit('set', configs);
      }
    } catch (e) {
      dispatch('errorHandler/throwDefaultError', e, { root: true });
    }
  },
};
